module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-ipad-landing.7b669e46.jpg";